import React from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

// mui
import { makeStyles, Typography } from '@material-ui/core';

// app
import styles from './AddEditParentClient.styles';
import { Button, FormContainer, FormFields, FormActions, FormGrid, FormText, FormFileDrop } from 'components';
import * as utils from 'utils';

AddEditParentClientView.propTypes = {
  fields: PropTypes.array,
  actions: PropTypes.array,
  logo: PropTypes.string || null,
};

export function AddEditParentClientView({ fields, actions, logo }) {
  const classes = makeStyles(styles, { name: 'AddEditParentClient' })();

  const defaultValues = utils.form.getInitialValues(fields);
  const validationSchema = utils.form.getValidationSchema(fields);

  const { control, reset, handleSubmit, formState, setValue } = useForm({
    defaultValues,
    ...(validationSchema && { resolver: yupResolver(validationSchema) }),
  });

  const { errors } = formState;
  const cancel = actions && actions.find((action) => action.name === 'cancel');
  const submit = actions && actions.find((action) => action.name === 'submit');

  const handleUpdateFile = (file) => {
    setValue('logo.0', file);
  };

  const onCancel = () => {
    cancel && utils.generic.isFunction(cancel.handler) && cancel.handler();
    reset();
  };

  const onSubmit = (data) => {
    return submit && utils.generic.isFunction(submit.handler) && submit.handler(data);
  };

  return (
    <div className={classes.root}>
      <FormContainer type="dialog" onSubmit={handleSubmit(onSubmit)} data-testid="form-addParentClient">
        <FormFields type="dialog">
          <FormGrid container>
            <FormGrid item xs={12}>
              <FormText {...utils.form.getFieldProps(fields, 'name')} control={control} error={errors.name} />
            </FormGrid>
            {logo ? (
              <FormGrid item xs={12}>
                <div className={classes.logo}>
                  <img src={logo} alt="logo" />
                </div>
              </FormGrid>
            ) : null}
            <FormGrid item xs={12}>
              <LogoInstructions />
              <FormFileDrop
                control={control}
                onChange={(file) => {
                  setValue('logo', file);
                }}
                {...utils.form.getFieldProps(fields, 'logo')}
                dragLabel={utils.string.t('admin.uploadLogoLabel')}
                showUploadPreview={false}
                showEditImage={true}
                handleUpdateFile={handleUpdateFile}
                fileNameLength={30}
                onlyOneFile
              />
            </FormGrid>
          </FormGrid>
        </FormFields>

        <FormActions type="dialog">
          {cancel && <Button text={cancel.label} variant="text" onClick={onCancel} disabled={formState.isSubmitting} />}
          {submit && <Button text={submit.label} type="submit" disabled={formState.isSubmitting} color="primary" />}
        </FormActions>
      </FormContainer>
    </div>
  );
}

export const LogoInstructions = () => {
  const classes = makeStyles(styles, { name: 'AddEditParentClient' })();

  return (
    <>
      <Typography variant="body2" className={classes.instructionsLabel}>
        {utils.string.t('admin.logoInstructions')}
      </Typography>
      <ol className={classes.instructions}>
        <li>
          <Typography variant="body2" className={classes.logoInstructionsText}>
            {utils.string.t('admin.logoInstructions1')}
          </Typography>
        </li>
        <li>
          <Typography variant="body2" className={classes.logoInstructionsText}>
            {utils.string.t('admin.logoInstructions2')}
          </Typography>
        </li>
      </ol>
    </>
  );
};
